export default function setZeroLeft(ps, compToAddPointer, containerPointer, compDefinitionPrototype) {
    compDefinitionPrototype.layout.x = 0
}
